import { lazy } from 'react';

const CircularityCertificatesManufacturerConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/consult/circularity-certificates',
			component: lazy(() => import('./CircularityCertificatesContainer'))
		}
	]
};

export default CircularityCertificatesManufacturerConfig;
